export class Helpers {
    static convertDateToLocalFormat(dateToConvert: Date) {

        if (!dateToConvert) {
            return null;
        }

        const date = new Date(dateToConvert);
        const offsetMsDate = date.getTimezoneOffset() * 60000;
        const formattedDate = new Date(date?.getTime() - offsetMsDate);
        return formattedDate;
    }

    static roundPrecision(value: number, decimals: number): number {
        const multipliedValue = Number(value + 'e' + decimals);
        const roundedValue = Math.round(multipliedValue);
        const fraction = 'e-' + decimals;
        return Number(roundedValue + fraction);
    }

    static toLocalCurrency(value: number) {
        const formattedValue = value.toString().replace('.', ',');
        return formattedValue + ' €';
    }

    static getCurrencyLocale(currency: string) {
        switch (currency) {
            case 'USD':
                return 'en-US';
            case 'CHF':
                return 'de-CH';
            case 'GBP':
                return 'en-GB';
            case 'AUD':
                return 'en-AU';
            case 'TRY':
                return 'tr';
            case 'NOK':
                return 'nb';
            default:
                return 'it';
        }
    }

    static getCurrencySymbol(currency: string) {
        if (currency) {
            return currency.trim().toUpperCase();
        }
        return 'EUR';
    }


    static percentageStyleColor(value: number) {
        let color = '';
        value < 0 ? color = '#ff7a7a' : color = '#8eff83';
        if (value === 0) {
            color = '#e1e4ff';
        }
        return color;
    }

    static getArrayKeyValue<TKey, TValue>(dictionary: { [id: string]: TValue }, options?: {
        arrayKey: string,
        arrayValue: string
        keyTransform?: (key: string) => any,
        valueTransform?: (value: TValue) => any
    }) {

        //#region //< Code only for debug purpose
        if (options.valueTransform || options.keyTransform) {
            // console.log('ALMOST ONE TRANSFORM FUNCTION IS DEFINED');
        }
        //#endregion

        const arrayResult = [];
        for (const key in dictionary) {
            if (Object.prototype.hasOwnProperty.call(dictionary, key)) {
                arrayResult.push({
                    [options.arrayKey]: (options.keyTransform ? options.keyTransform(key) : key) as TKey,
                    [options.arrayValue]: (options.valueTransform ? options.valueTransform(dictionary[key]) : dictionary[key]) as TValue
                });
            }
        }

        return arrayResult;
    }

}
